module.exports = __webpack_public_path__ + "static/media/lk-old-dutch-hospital.270a2747.png";